<template>
  <wc-data-box
    title='Results'
    titleIcon='mdi-check-all'
    showSearch
    :loading='isLoading'
    v-model='search'
  >
    <v-data-table
      :items='systems'
      :headers='headers'
      :items-per-page='-1'
      :search='search'
      dense
      @click:row="openProject"
    >
      <template v-slot:item.name='{ item }'>
        {{ item.name }}<br>
        <div class='grey--text' style='margin-top: -7px; margin-bottom: -2px;'>
          <small v-if='item.site_city'>{{ item.site_address }}, {{ item.site_city }}</small>
          <small v-else>{{ item.site_address }}</small>
        </div>
      </template>
      <template v-slot:item.install_date='{ item }'>
        {{ item.install_date | shortDate }}
      </template>
      <template v-slot:item.is_capital_system='{ item }'>
        <span v-if='!item.is_capital_system'>Yes</span>
      </template>
      <template v-slot:item.subd_tier_obj.su_price='{ item }'>
        <span v-if='item.subd_tier_obj'>{{ item.subd_tier_obj.su_price | intMoney }}</span>
      </template>
      <template v-slot:item.subd_tier_obj.bd_price='{ item }'>
        <span v-if='item.subd_tier_obj'>{{ item.subd_tier_obj.bd_price | intMoney }}</span>
      </template>
      <!--       
      <template v-slot:item.subd_obj_tier='{ item }'>
        <span v-if='item.subd_tier_obj'>{{ item.subd_tier_obj.tier_number }}</span>
      </template>
      <template v-slot:item.su_price='{ item }'>
        <span v-if='item.subd_tier_obj'>{{ item.subd_tier_obj.su_price | decMoney }}</span>
      </template>
      <template v-slot:item.su_time='{ item }'>
        <span v-if='item.subd_tier_obj'>{{ item.subd_tier_obj.su_time | int }}</span>
      </template>
      <template v-slot:item.bd_price='{ item }'>
        <span v-if='item.subd_tier_obj'>{{ item.subd_tier_obj.bd_price | decMoney }}</span>
      </template>
      <template v-slot:item.bd_time='{ item }'>
        <span v-if='item.subd_tier_obj'>{{ item.subd_tier_obj.bd_time | int }}</span>
      </template>
      -->
    </v-data-table>
  </wc-data-box>
</template>

<script>
import miscServices from '@/services/misc'

export default {
  name: 'irrigation-table',
  props: {
    systems: {
      required: true
    },
    isLoading: {
      required: true,
      type: Boolean,
      default: false
    },
    showConflicts: {
      required: true,
      type: Boolean,
      default: false
    },
    reportType: {
      required: false,
      type: String,
      defulat: ''
    }
  },
  computed: {
    headers () {
      let tmp = [
        { text: 'Number', value: 'number', width: '96' },
        { text: 'Name', value: 'name', width: '340' },
        { text: 'Install Date', value: 'install_date', width: '120' },
        { text: 'City', value: 'site_city', align: ' d-none' },
        { text: 'Address', value: 'site_address', align: ' d-none' },
        { text: 'Takeover', value: 'is_capital_system', align: 'center', width: '120' },
      ]
      if (this.reportType === 'SBP') {
        tmp.push({ text: 'Tier', value: 'subd_tier_obj.tier_number' })
        tmp.push({ text: 'SU Price', value: 'subd_tier_obj.su_price' })
        tmp.push({ text: 'SU Time', value: 'subd_tier_obj.su_time' })
        tmp.push({ text: 'BD Price', value: 'subd_tier_obj.bd_price' })
        tmp.push({ text: 'BD Time', value: 'subd_tier_obj.bd_time' })
      } else {
        tmp.push({ text: 'Conflicts', value: 'conflict_count', width: '120' })
        tmp.push({ text: 'Conflict Status', value: 'conflict_status' })
        tmp.push({ text: '', value: 'conflict_status' })
      }
      return tmp
    }
  },
  data: () => ({
    search: ''
  }),
  methods: {
    openProject (proj) {
      if (this.reportType === 'SBP') {
        miscServices.openInNewTab({ name: 'IrrigationOverview', params: { id: proj.project_id } })
      } else {
        this.$emit('openProject', proj)
      }
    }
  }
}
</script>
